import type { FeeProfile } from '../engine/types';

export interface ValidationResult {
  ok: boolean;
  errors: string[];
}

const REQUIRED_TOP_LEVEL = [
  'profile_id',
  'last_verified_at',
  'marketplace',
  'currency',
  'locale',
  'referralFees',
  'fulfillmentFees',
  'additionalFees',
  'storageRates',
  'sizeTierLimits',
  'apparelCategories'
];

export function validateProfile(candidate: unknown): ValidationResult {
  const errors: string[] = [];

  if (!candidate || typeof candidate !== 'object') {
    return { ok: false, errors: ['Profile is not an object'] };
  }

  const profile = candidate as Record<string, unknown>;
  for (const key of REQUIRED_TOP_LEVEL) {
    if (!(key in profile)) {
      errors.push(`Missing required key: ${key}`);
    }
  }

  if (!Array.isArray(profile.referralFees) || profile.referralFees.length === 0) {
    errors.push('referralFees must be a non-empty array');
  }

  if (!profile.fulfillmentFees || typeof profile.fulfillmentFees !== 'object') {
    errors.push('fulfillmentFees must be an object');
  }

  if (!profile.storageRates || typeof profile.storageRates !== 'object') {
    errors.push('storageRates must be an object');
  }

  if (!Array.isArray(profile.apparelCategories)) {
    errors.push('apparelCategories must be an array');
  }

  return { ok: errors.length === 0, errors };
}

export function assertValidProfile(candidate: unknown): FeeProfile {
  const result = validateProfile(candidate);
  if (!result.ok) {
    throw new Error(`Invalid fee profile: ${result.errors.join('; ')}`);
  }
  return candidate as FeeProfile;
}
